import React from 'react';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import './key-handoff-submit-bar.scss';

interface KeyHandoffSubmitBarProps {
  isSubmitting: boolean;
  disabled: boolean;
  onSubmit: () => void;
}

const KeyHandoffSubmitBar = ({
  isSubmitting,
  disabled,
  onSubmit,
}: KeyHandoffSubmitBarProps) => {
  return (
    <div className="key-handoff-submit-bar">
      <LoadingButton
        actionText="Submit"
        isSubmitting={isSubmitting}
        onClick={onSubmit}
        size="bar"
        disabled={disabled}
      />
    </div>
  );
};

export default KeyHandoffSubmitBar;
